import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';

export function useTrackingDashboard(contactId, days = 30) {
  return useQuery({
    queryKey: ['tracking', contactId, days],
    queryFn: () => api.get(`/contacts/${contactId}/tracking?days=${days}`).then(r => r.data),
    enabled: !!contactId,
    refetchInterval: 60000, // alle 60s aktualisieren
  });
}

export function useTrackingSnippet(contactId) {
  return useQuery({
    queryKey: ['tracking-snippet', contactId],
    queryFn: () => api.get(`/contacts/${contactId}/tracking/snippet`).then(r => r.data),
    enabled: !!contactId,
  });
}

export function usePurgeTracking() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (contactId) => api.delete(`/contacts/${contactId}/tracking`),
    onSuccess: (_, contactId) => {
      qc.invalidateQueries({ queryKey: ['tracking', contactId] });
    },
  });
}
